import { I18nLocale, LOCALE } from 'utils';

export const imageBreakpoints: Record<number, number | number[]> = {
  1920: 200,
  1680: 200,
  1600: 200,
  1536: 200,
  1440: 200,
  1366: 200,
  1280: 200,
  428: [200, 300, 400],
  414: [200, 300, 400],
  412: [200, 300, 400],
  393: [200, 300, 400],
  390: [200, 300, 400],
  385: [200, 300, 400],
  384: [200, 300, 400],
  375: [200, 300, 400],
  360: [200, 300, 400],
  320: [200, 300, 400],
};

export const categoryImages: Record<I18nLocale, Record<string, string>> = {
  [LOCALE.PL]: {
    GOTOWANIE:
      '/content/menu-sidebar/49fcfc43-3d74-420a-f0d9-200f2e5ee800.avif',
    'AKCESORIA KUCHENNE':
      '/content/menu-sidebar/df84fa0a-2b35-4349-adf3-6a66499fc25d.avif',
    PREZENTY: '/content/menu-sidebar/95ea082f-38e2-4b24-ea47-74dd36df2800.avif',
    ŁAZIENKA: '/content/menu-sidebar/af70582b-fc16-4a4a-0d12-5d2938ceb100.avif',
    BAR: '/content/menu-sidebar/07c68d8d-2dac-469d-f44a-02f3f71d5e00.avif',
    'DOMOWA PRODUKCJA':
      '/content/menu-sidebar/a99d172b-501c-48b5-0c3e-272eaf333600.avif',
    OGRÓD: '/content/menu-sidebar/fa99e396-d211-4d3b-0903-7bb457101800.avif',
    DOM: '/content/menu-sidebar/33672081-731f-4601-6749-87980e2f0700.avif',
    SUPERMARKET:
      '/content/menu-sidebar/1b786b42-c383-4246-302b-306fd1565e00.avif',
    'MAŁE AGD':
      '/content/menu-sidebar/d14726d7-267a-4337-83d9-da523c895300.avif',
    PORZĄDKI: '/content/menu-sidebar/587c7be8-28c6-415f-8282-463eaf7d0200.avif',
    'SALON & SYPIALNIA':
      '/content/menu-sidebar/aadc6154-7629-4458-4f1d-d11137111800.avif',
    'MUST HAVE':
      '/content/menu-sidebar/bc861a3e-0e0b-43b2-b6fb-da5cfc621100.avif',
    'ŚWIAT DZIECKA':
      '/content/menu-sidebar/f9f0e914-686a-4a99-7a7a-2ab2617c8600.avif',
    'PRZECHOWYWANIE ŻYWNOŚCI':
      '/content/menu-sidebar/74f429fb-cced-4f19-f8c9-ff9001379f00.avif',
    'ZASTAWA STOŁOWA':
      '/content/menu-sidebar/6679258b-a0b3-41f2-b853-4b976642e500.avif',
    TURYSTYKA:
      '/content/menu-sidebar/84b2ab8e-ef34-476d-77d0-d8a7b5f55b00.avif',
    'KATEGORIE SPECJALNE':
      '/content/menu-sidebar/beafa738-6f6f-4d37-8b09-7cb21a02774b.avif',
    'KAWA I HERBATA':
      '/content/menu-sidebar/ea32fbdc-57da-4d7a-a4fc-d6d1ef0065fb.avif',
    NOWOŚCI: '/content/menu-sidebar/7bb3041c-98d3-4ee6-b617-6c2a4d104c54.avif',
    'NOŻE KUCHENNE':
      '/content/menu-sidebar/9a3dce9d-0452-4034-9370-832d43bec792.avif',
    PIECZENIE:
      '/content/menu-sidebar/264ce6d4-ba17-4907-81e5-491d924fcf34.avif',
    PROMOCJE: '/content/menu-sidebar/7f6e9b95-8c16-43d0-af53-1a5953c1cbac.avif',
    WYPRZEDAŻ:
      '/content/menu-sidebar/4662fe7b-3719-4fe9-b971-567e6e1f2df5.avif',
  },
  [LOCALE.SK]: {
    KUCHYŇA: '/content/menu-sidebar/49fcfc43-3d74-420a-f0d9-200f2e5ee800.avif',
    DARČEKY: '/content/menu-sidebar/95ea082f-38e2-4b24-ea47-74dd36df2800.avif',
    KÚPEĽŇA: '/content/menu-sidebar/af70582b-fc16-4a4a-0d12-5d2938ceb100.avif',
    'BAROVÉ PRÍSLUŠENSTVO':
      '/content/menu-sidebar/07c68d8d-2dac-469d-f44a-02f3f71d5e00.avif',
    'DOMÁCA VÝROBA':
      '/content/menu-sidebar/a99d172b-501c-48b5-0c3e-272eaf333600.avif',
    ZÁHRADA: '/content/menu-sidebar/fa99e396-d211-4d3b-0903-7bb457101800.avif',
    DEKORÁCIE:
      '/content/menu-sidebar/33672081-731f-4601-6749-87980e2f0700.avif',
    SUPERMARKET:
      '/content/menu-sidebar/1b786b42-c383-4246-302b-306fd1565e00.avif',
    'MALÉ DOMÁCE SPOTREBIČE':
      '/content/menu-sidebar/d14726d7-267a-4337-83d9-da523c895300.avif',
    UPRATOVANIE:
      '/content/menu-sidebar/587c7be8-28c6-415f-8282-463eaf7d0200.avif',
    'OBÝVAČKA A SPÁLŇA':
      '/content/menu-sidebar/aadc6154-7629-4458-4f1d-d11137111800.avif',
    'MUST HAVE':
      '/content/menu-sidebar/bc861a3e-0e0b-43b2-b6fb-da5cfc621100.avif',
    'DETSKÝ SVET':
      '/content/menu-sidebar/f9f0e914-686a-4a99-7a7a-2ab2617c8600.avif',
    'ORGANIZÁCIA A SKLADOVANIE':
      '/content/menu-sidebar/74f429fb-cced-4f19-f8c9-ff9001379f00.avif',
    JEDÁLEŇ: '/content/menu-sidebar/6679258b-a0b3-41f2-b853-4b976642e500.avif',
    CESTOVANIE:
      '/content/menu-sidebar/84b2ab8e-ef34-476d-77d0-d8a7b5f55b00.avif',
  },
  [LOCALE.CZ]: {
    KUCHYNĚ: '/content/menu-sidebar/49fcfc43-3d74-420a-f0d9-200f2e5ee800.avif',
    DÁRKY: '/content/menu-sidebar/95ea082f-38e2-4b24-ea47-74dd36df2800.avif',
    KOUPELNA: '/content/menu-sidebar/af70582b-fc16-4a4a-0d12-5d2938ceb100.avif',
    'BAROVÉ PŘÍSLUŠENSTVÍ':
      '/content/menu-sidebar/07c68d8d-2dac-469d-f44a-02f3f71d5e00.avif',
    'DOMÁCÍ POTŘEBY':
      '/content/menu-sidebar/a99d172b-501c-48b5-0c3e-272eaf333600.avif',
    ZAHRADA: '/content/menu-sidebar/fa99e396-d211-4d3b-0903-7bb457101800.avif',
    DEKORACE: '/content/menu-sidebar/33672081-731f-4601-6749-87980e2f0700.avif',
    SUPERMARKET:
      '/content/menu-sidebar/1b786b42-c383-4246-302b-306fd1565e00.avif',
    'MALÉ DOMÁCÍ SPOTŘEBIČE':
      '/content/menu-sidebar/d14726d7-267a-4337-83d9-da523c895300.avif',
    'ÚKLIDOVÉ PROSTŘEDKY':
      '/content/menu-sidebar/587c7be8-28c6-415f-8282-463eaf7d0200.avif',
    'OBÝVACÍ POKOJ A LOŽNICE':
      '/content/menu-sidebar/aadc6154-7629-4458-4f1d-d11137111800.avif',
    'MUSÍ MÍT':
      '/content/menu-sidebar/bc861a3e-0e0b-43b2-b6fb-da5cfc621100.avif',
    'DĚTSKÝ SVĚT':
      '/content/menu-sidebar/f9f0e914-686a-4a99-7a7a-2ab2617c8600.avif',
    'ORGANIZACE A SKLADOVÁNÍ':
      '/content/menu-sidebar/74f429fb-cced-4f19-f8c9-ff9001379f00.avif',
    JÍDELNA: '/content/menu-sidebar/6679258b-a0b3-41f2-b853-4b976642e500.avif',
    CESTOVNÍ: '/content/menu-sidebar/84b2ab8e-ef34-476d-77d0-d8a7b5f55b00.avif',
  },
  [LOCALE.RO]: {
    KUCHNIA: '/content/menu-sidebar/49fcfc43-3d74-420a-f0d9-200f2e5ee800.avif',
    PREZENTY: '/content/menu-sidebar/95ea082f-38e2-4b24-ea47-74dd36df2800.avif',
    ŁAZIENKA: '/content/menu-sidebar/af70582b-fc16-4a4a-0d12-5d2938ceb100.avif',
    'AKCESORIA BAROWE':
      '/content/menu-sidebar/07c68d8d-2dac-469d-f44a-02f3f71d5e00.avif',
    'DOMOWA PRODUKCJA':
      '/content/menu-sidebar/a99d172b-501c-48b5-0c3e-272eaf333600.avif',
    OGRÓD: '/content/menu-sidebar/fa99e396-d211-4d3b-0903-7bb457101800.avif',
    DEKORACJE:
      '/content/menu-sidebar/33672081-731f-4601-6749-87980e2f0700.avif',
    SUPERMARKET:
      '/content/menu-sidebar/1b786b42-c383-4246-302b-306fd1565e00.avif',
    'MAŁE AGD':
      '/content/menu-sidebar/d14726d7-267a-4337-83d9-da523c895300.avif',
    PORZĄDKI: '/content/menu-sidebar/587c7be8-28c6-415f-8282-463eaf7d0200.avif',
    'SALON & SYPIALNIA':
      '/content/menu-sidebar/aadc6154-7629-4458-4f1d-d11137111800.avif',
    'MUST HAVE':
      '/content/menu-sidebar/bc861a3e-0e0b-43b2-b6fb-da5cfc621100.avif',
    'ŚWIAT DZIECKA':
      '/content/menu-sidebar/f9f0e914-686a-4a99-7a7a-2ab2617c8600.avif',
    'ORGANIZACJA I PRZECHOWYWANIE':
      '/content/menu-sidebar/74f429fb-cced-4f19-f8c9-ff9001379f00.avif',
    JADALNIA: '/content/menu-sidebar/6679258b-a0b3-41f2-b853-4b976642e500.avif',
    TURYSTYKA:
      '/content/menu-sidebar/84b2ab8e-ef34-476d-77d0-d8a7b5f55b00.avif',
  },
  [LOCALE.DE]: {
    KOCHEN: '/content/menu-sidebar/49fcfc43-3d74-420a-f0d9-200f2e5ee800.avif',
    KÜCHENZUBEHÖR:
      '/content/menu-sidebar/df84fa0a-2b35-4349-adf3-6a66499fc25d.avif',
    PREZENTY: '/content/menu-sidebar/95ea082f-38e2-4b24-ea47-74dd36df2800.avif',
    ŁAZIENKA: '/content/menu-sidebar/af70582b-fc16-4a4a-0d12-5d2938ceb100.avif',
    BAR: '/content/menu-sidebar/07c68d8d-2dac-469d-f44a-02f3f71d5e00.avif',
    'DOMOWA PRODUKCJA':
      '/content/menu-sidebar/a99d172b-501c-48b5-0c3e-272eaf333600.avif',
    GARTEN: '/content/menu-sidebar/fa99e396-d211-4d3b-0903-7bb457101800.avif',
    HEIM: '/content/menu-sidebar/33672081-731f-4601-6749-87980e2f0700.avif',
    SUPERMARKET:
      '/content/menu-sidebar/1b786b42-c383-4246-302b-306fd1565e00.avif',
    'MAŁE AGD':
      '/content/menu-sidebar/d14726d7-267a-4337-83d9-da523c895300.avif',
    PORZĄDKI: '/content/menu-sidebar/587c7be8-28c6-415f-8282-463eaf7d0200.avif',
    'SALON & SYPIALNIA':
      '/content/menu-sidebar/aadc6154-7629-4458-4f1d-d11137111800.avif',
    'MUST-HAVES':
      '/content/menu-sidebar/bc861a3e-0e0b-43b2-b6fb-da5cfc621100.avif',
    KINDERWELT:
      '/content/menu-sidebar/f9f0e914-686a-4a99-7a7a-2ab2617c8600.avif',
    LEBENSMITTELAUFBEWAHRUNG:
      '/content/menu-sidebar/74f429fb-cced-4f19-f8c9-ff9001379f00.avif',
    TAFELGESCHIRR:
      '/content/menu-sidebar/6679258b-a0b3-41f2-b853-4b976642e500.avif',
    TURYSTYKA:
      '/content/menu-sidebar/84b2ab8e-ef34-476d-77d0-d8a7b5f55b00.avif',
    'SPEZIELLE KATEGORIEN':
      '/content/menu-sidebar/beafa738-6f6f-4d37-8b09-7cb21a02774b.avif',
    'KAFFEE & TEE':
      '/content/menu-sidebar/ea32fbdc-57da-4d7a-a4fc-d6d1ef0065fb.avif',
    NEUHEITEN:
      '/content/menu-sidebar/7bb3041c-98d3-4ee6-b617-6c2a4d104c54.avif',
    KÜCHENMESSER:
      '/content/menu-sidebar/9a3dce9d-0452-4034-9370-832d43bec792.avif',
    BACKEN: '/content/menu-sidebar/264ce6d4-ba17-4907-81e5-491d924fcf34.avif',
    WERBEAKTIONEN:
      '/content/menu-sidebar/7f6e9b95-8c16-43d0-af53-1a5953c1cbac.avif',
    VERKÄUFE: '/content/menu-sidebar/4662fe7b-3719-4fe9-b971-567e6e1f2df5.avif',
  },
};
